module.exports = __webpack_public_path__ + "img/Flunder_11.902b4983.jpg";